import MROFullScreenRightDrawer from 'components/fullwidth_dialog'
import ToolBar from 'components/ToolBar'
import React from 'react'
import Dispatches from 'views/Commercial/Parts/Sales/Dispatches'

function DispatchAccounts(props) {

    const { salesId, handleClose } = props

    return (
        <MROFullScreenRightDrawer open={true}>

            <ToolBar handleClose={handleClose} titleName={"Dispatches"} />


            <Dispatches salesId={salesId} tab={"acc"} />


        </MROFullScreenRightDrawer>
    )
}

export default DispatchAccounts